var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1299 0.75L17.2051 0.753906C17.279 0.762252 17.3509 0.783477 17.418 0.81543C17.5074 0.858051 17.5861 0.919379 17.6475 0.995117V0.996094L22.4912 7L17.6475 13.0039C17.586 13.0799 17.5076 13.1418 17.418 13.1846C17.3283 13.2273 17.2299 13.2499 17.1299 13.25H1.02344L5.43262 7.78516C5.8021 7.32715 5.8021 6.67285 5.43262 6.21484L1.02344 0.75H17.1299Z",
    stroke: "#555B67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantIcon);
export default __webpack_public_path__ + "static/media/important-icon.d412912670da4e8ce999f7bb686ab87a.svg";
export { ForwardRef as ReactComponent };